<button
  type="button"
  class="btn copy-button"
  (click)="copy()"
  [attr.title]="title()" [ngClass]="{ 'is-input-group': isInputGroup(), 'with-border': withBorder() }"
>
  <my-global-icon iconName="copy"></my-global-icon>

  <ng-content></ng-content>
</button>
